<div id='ll-grid' class="grid">
    <div id='ll-back' class="group-background"></div>
    <div id='ll-container'>
        <div class='ll-item' *ngFor='let iLangauge of availableLanguages' (click)='selected(iLangauge.code)'>
            <div class='ll-subcode'>{{iLangauge.subCode}}</div>
            <div class="ll-text">{{iLangauge.name}}</div>
            <app-radio-button class="ll-radio" [groupName]="'ll-radio'" [checkValue]="currentLanguage === iLangauge.code"></app-radio-button>
        </div>
    </div>
</div>